<template>
  <div class="vip-plans-card">
    <h3 class="section-title">会员套餐</h3>
    <div class="plans-grid">
      <!-- 免费套餐 -->
      <div class="plan-card free">
        <div class="plan-name">免费版</div>
        <div class="plan-price">
          <span class="amount">免费</span>
        </div>
        <div class="plan-features">
          <div class="feature">✅ 每日3次生成</div>
          <div class="feature">✅ 基础功能使用</div>
          <div class="feature">✅ 无需付费</div>
          <br>
        </div>
        <button
          class="plan-btn free"
          :disabled="vipLevel !== 'VIP0' && vipLevel !== ''"
          @click="goToPay('VIP0')"
        >
          {{ vipLevel === 'VIP0' ? '当前使用' : '已升级' }}
        </button>
      </div>

      <!-- 基础会员 -->
      <div class="plan-card" :class="{ recommended: true }">
        <div class="plan-name">基础会员</div>
        <div class="plan-price">
          <span class="symbol">¥</span>
          <span class="amount">9.9</span>
          <span class="unit">/月</span>
        </div>
        <div class="plan-features">
          <div class="feature">✅ 每日20次生成</div>
          <div class="feature">✅ 无广告</div>
          <div class="feature">✅ 优先响应</div>
          <br>
        </div>
        <button
          class="plan-btn"
          :disabled="vipLevel === 'VIP1' || vipLevel === 'VIP2'"
          @click="goToPay('VIP1')"
        >
          {{ vipLevel === 'VIP1' ? '已开通' : '立即开通' }}
        </button>
      </div>

      <!-- 专业会员 -->
      <div class="plan-card premium">
        <div class="plan-name">专业会员</div>
        <div class="plan-price">
          <span class="symbol">¥</span>
          <span class="amount">19.9</span>
          <span class="unit">/月</span>
        </div>
        <div class="plan-features">
          <div class="feature">✅ 每日100次生成</div>
          <div class="feature">✅ 无广告</div>
          <div class="feature">✅ 最高优先级</div>
          <div class="feature">✅ 永久历史记录</div>
        </div>
        <button
          class="plan-btn premium"
          :disabled="vipLevel === 'VIP2'"
          @click="goToPay('VIP2')"
        >
          {{ vipLevel === 'VIP2' ? '已开通' : '立即开通' }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "VipPlans",
  computed: {
    // 从 Vuex 获取当前 VIP 等级
    vipLevel() {
      return this.$store.getters.getUserInfo.vipLevel || "VIP0";
    }
  },
  methods: {
    goToPay(level) {
      if (level === 'VIP0') {
        this.$topTip("您当前正在使用免费版");
      } else if (level === 'VIP1' && this.vipLevel === 'VIP1') {
        this.$topTip("您已开通基础会员");
      } else if (level === 'VIP2' && this.vipLevel === 'VIP2') {
        this.$topTip("您已开通最高会员");
      } else {
        this.$topTip("内测期间无需付费");
      }
    }
  }
};
</script>

<style scoped>
.vip-plans-card {
  width: 100%;
  max-width: 1000px;
  margin-top: 40px;
}

.section-title {
  font-size: 1.2rem;
  font-weight: 600;
  color: #1e293b;
  margin-bottom: 1rem;
  text-align: center;
}

.plans-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 1.2rem;
}

.plan-card {
  border: 2px solid #e2e8f0;
  border-radius: 16px;
  padding: 1.8rem;
  text-align: center;
  background: #fff;
  transition: all 0.2s;
}
.plan-card:hover {
  border-color: #4f46e5;
  transform: translateY(-2px);
}

/* 免费版样式 */
.plan-card.free {
  border-color: #94a3b8;
}
.plan-card.free .plan-price .amount {
  font-size: 2.2rem;
  font-weight: 700;
  color: #64748b;
}
.plan-btn.free {
  background: #64748b;
}
.plan-btn.free:hover {
  background: #475569;
}

/* 推荐 */
.plan-card.recommended {
  border-color: #f59e0b;
  position: relative;
}
.plan-card.recommended::before {
  content: "推荐";
  position: absolute;
  top: -12px;
  left: 50%;
  transform: translateX(-50%);
  background: #f59e0b;
  color: #fff;
  padding: 2px 12px;
  border-radius: 12px;
  font-size: 0.75rem;
}

/* 专业版 */
.plan-card.premium {
  border-color: #ec4899;
}

.plan-name {
  font-size: 1.1rem;
  font-weight: 600;
  color: #1e293b;
  margin-bottom: 1rem;
}
.plan-price {
  margin-bottom: 1.2rem;
}
.plan-price .symbol {
  font-size: 1rem;
  color: #64748b;
}
.plan-price .amount {
  font-size: 2.2rem;
  font-weight: 700;
  color: #4f46e5;
}
.plan-card.premium .plan-price .amount {
  color: #ec4899;
}
.plan-price .unit {
  font-size: 0.9rem;
  color: #64748b;
}

.plan-features {
  text-align: left;
  margin-bottom: 1.2rem;
}
.plan-features .feature {
  font-size: 0.9rem;
  color: #475569;
  padding: 0.3rem 0;
}

.plan-btn {
  width: 100%;
  background: #4f46e5;
  color: #fff;
  border: none;
  border-radius: 10px;
  padding: 0.8rem;
  font-size: 0.95rem;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s;
}
.plan-btn:hover:not(:disabled) {
  background: #4338ca;
}
.plan-btn.premium {
  background: #ec4899;
}
.plan-btn.premium:hover:not(:disabled) {
  background: #db2777;
}

/* 禁用按钮样式 */
.plan-btn:disabled {
  background: #94a3b8 !important;
  cursor: not-allowed;
  opacity: 0.7;
}
</style>